<template>
  <modal
    :width="550"
    :click-to-close="false"
    name="SPIndicatorsModal"
    height="auto"
    @before-open="beforeOpen"
    @opened="opened"
    @closed="closed"
  >
    <div class="indicatorsModal">
      <h3>Select Indicators to View</h3>
      <h4>Location: {{ GSGo.location }}
        <br>Category: {{ GSGo.category }}
      </h4>
      <div>
        Select up to {{ maxPanelCount }} indicators to View
      </div>
      <div class="cf">
        <div class="fl">
          ({{ selectedIndicatorIds.length }} of {{ maxCheck }} selected)
        </div>
        <div class="fr">
          <a
            ref="clearLink"
            href="#"
            @click.prevent="clearAll"
            @keydown.shift.tab="setFocusToCancel"
          >Clear all</a>
        </div>
      </div>
      <div>
        <fieldset>
          <ul>
            <li
              v-for="(item, index) in allPossibleIndicators"
              :key="item.id"
              class="form-check-inline col-12"
            >
              <input
                :id="'cbx_' + item.id"
                :value="item.id"
                :ref="'cbx_' + index"
                v-model="selectedIndicatorIds"
                type="checkbox"
              >
              <label
                :for="'cbx_' + item.id"
                class="mb-0 ml-1">{{ item.abbr }}</label>
            </li>
          </ul>
        </fieldset>
      </div>
      <div class="modalButtons">
        <button
          :disabled="okDisabled"
          :class="{disabledButton: okDisabled}"
          class="default-button"
          @click="okClicked">OK</button>
        <button
          ref="cancel"
          @keydown.tab="setFocusToClearLink"
          @click="cancelClicked">Cancel</button>
      </div>
    </div>
  </modal>
</template>

<script>
/* global triggerOmnitureInteractions */
import _ from 'lodash';
import { mapState } from 'vuex';

export default {
  props: {
    indicators: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      // updated by v-model binding to checkboxes
      selectedIndicatorIds: [],
    };
  },
  computed: {
    ...mapState({
      spgsLink: state => state.spgsLink,
      GSGo: state => state.SP.GSGo,
      maxPanelCount: state => state.SP.maxPanelCount,
      lku: state => state.lku,
    }),
    allPossibleIndicators() {
      return this.$store.getters['SP/allPossibleIndicators'];
    },
    maxCheck() {
      return Math.min(this.maxPanelCount, this.allPossibleIndicators.length);
    },
    okDisabled() {
      return this.selectedIndicatorIds.length === 0;
    },
  },
  watch: {
    selectedIndicatorIds(newVal, oldVal) {
      // limit the number of indicators to this.maxPanelCount
      if (newVal.length > this.maxPanelCount) {
        this.selectedIndicatorIds = oldVal;
      }
    },
  },
  methods: {
    beforeOpen() {
      this.selectedIndicatorIds = _(this.indicators).map('id').value();
    },
    opened() {
      // set focus to the first checkbox
      // this.$refs.cbx_0 returns an array for some reason.
      // https://forum.vuejs.org/t/how-to-set-focus-to-input/10672/6
      this.$refs.cbx_0[0].focus();
    },
    closed() {
      this.$emit('modalClosed');
    },
    clearAll() {
      this.selectedIndicatorIds = [];
    },
    hideModal() {
      this.$modal.hide('SPIndicatorsModal');
    },
    okClicked() {
      const newIndicators = _(this.selectedIndicatorIds)
        .map(id => this.lku.Question[id])
        .orderBy('sort', 'asc')
        .value();
      // only update the indicators if a change was made
      if (!_.isEqual(newIndicators, this.indicators)) {
        const newIndicatorIds = _(newIndicators).map('id').value();
        triggerOmnitureInteractions(`${process.env.InteractionIdentifier}-LI ${newIndicatorIds.join('-')},${this.GSGo.locationId},${this.GSGo.categoryId}`);
        // set goClicked to true to prevent panel interactions from being triggered
        this.$store.commit('SP/setGoClicked', true);
        this.$emit('indicatorsChanged', newIndicators);
      }
      this.hideModal();
    },
    cancelClicked() {
      this.hideModal();
    },
    setFocusToCancel() {
      // use nextTick to prevent the focus from jumping twice
      this.$nextTick(() => {
        this.$refs.cancel.focus();
      });
    },
    setFocusToClearLink(event) {
      // set focus on tab key only (not shift-tab)
      if (!event.shiftKey) {
        // use nextTick to prevent focus from jumping twice
        this.$nextTick(() => {
          this.$refs.clearLink.focus();
        });
      }
    },
  },

};

</script>

<style scoped>
    .modalButtons {
      text-align: center;
      padding: 10px;
    }
    .modalButtons button {
      width: 80px;
      margin: 0 5px;
      height: 37px;
      font-weight: bold;
    }
    .default-button {
      color: white;
      background-color: RGB(8,66,57);
    }
    .disabledButton {
    background-color: #F6F6F6;
    color: #CECECE;
    }
    .indicatorsModal {
      padding: 4px 10px 4px 10px;
      border: 3px solid #bab9b9;
    }
    .indicatorsModal h3 {
      font-size: 18px;
      font-weight: bold;
      color: white;
      background-color: RGB(8,66,57);
      text-align: center;
      margin-top: 0;
    }
    .indicatorsModal h4 {
      font-size: 16px;
      font-weight: bold;
      margin: 10px 0;
    }
    .indicatorsModal ul {
      list-style-type: none;
      padding-left: 5px;
      margin: 5px 0;
    }
    .fl {
      float: left; _display: inline;
    }
    .fr {
      float: right; _display: inline;
    }
    .cf:before, .cf:after {
       content: " "; display: table;
    }
    .cf:after {
       clear: both;
    }
    .cf {
       *zoom: 1;
    }
    fieldset {
      border: 1px solid #ccc;
      padding: 0;
      margin: 0;
    }

</style>



// WEBPACK FOOTER //
// src/components/SP/SPIndicatorsModal.vue